import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Products from "@/pages/admin/Products";
import Stores from "@/pages/admin/Stores";
import AdminRoutes from "@/pages/admin/Routes";
import Salesmen from "@/pages/admin/Salesmen";
import AdminOrders from "@/pages/admin/Orders";
import Attendance from "@/pages/admin/Attendance";
import LiveLocation from "@/pages/admin/LiveLocation";
import Reports from "@/pages/admin/Reports";
import Ledger from "@/pages/admin/Ledger";
import Backup from "@/pages/admin/Backup";
import SalesmanLayout from "@/pages/salesman/SalesmanLayout";
import SalesmanHome from "@/pages/salesman/Home";
import SalesmanStores from "@/pages/salesman/Stores";
import StoreDetail from "@/pages/salesman/StoreDetail";
import NewOrder from "@/pages/salesman/NewOrder";
import EditOrder from "@/pages/salesman/EditOrder";
import MyOrders from "@/pages/salesman/MyOrders";
import Profile from "@/pages/salesman/Profile";
import { Toaster } from "sonner";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/app"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-center" />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="reports" element={<Reports />} />
              <Route path="ledger" element={<Ledger />} />
              <Route path="live" element={<LiveLocation />} />
              <Route path="products" element={<Products />} />
              <Route path="stores" element={<Stores />} />
              <Route path="routes" element={<AdminRoutes />} />
              <Route path="salesmen" element={<Salesmen />} />
              <Route path="backup" element={<Backup />} />
            </Route>

            <Route
              path="/app"
              element={
                <ProtectedRoute role="salesman">
                  <SalesmanLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<SalesmanHome />} />
              <Route path="stores" element={<SalesmanStores />} />
              <Route path="stores/:id" element={<StoreDetail />} />
              <Route path="stores/:id/order" element={<NewOrder />} />
              <Route path="orders" element={<MyOrders />} />
              <Route path="orders/:id/edit" element={<EditOrder />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
